$(function() {
    
  // FORM VALIDATION
  
  // Part A Function
  function validatePartA() {
    var value = $(this).data('value');
    var target = $(this).data('target');
    var next = $(this).data('next');
    $(target).val(value);
    $(next).slideDown();
    $(this).prop('disabled', true);
    $([document.documentElement, document.body]).animate({
        scrollTop: $(next).offset().top - 100
    }, 1000);
  }
 
  // Execute Part A on user verification
  $('.userVerify').on('click tap', validatePartA);
  
  
  // Part 1
  $('#part1 input[type=radio]').on('click tap', function(){
    var noCount = $('#part1 input[value=NO]:checked').length;
    var yesCount = $('#part1 input[value=YES]:checked').length;
    var totalCount = ($('#part1 input[type=radio]').length) / 2;
    
    // if any YES, show alert
    if (yesCount > 0) { 
      $('#part1-alert').addClass('text-sb-grey-600').removeClass('text-sb-green').html("We can't accept those items. We will only issue credit for functional used gear that is within the <a href=\"/pages/preloved#preloved-details\" title=\"Standards\" aria-label=\"Standards\">SB Pre-Loved program standards</a>. Any gear that doesn't pass muster will be donated. No items will be returned to you for any reason."); 
      $('#part1 input.userVerify').prop('disabled', true); 
    }
    
    // if all NO, enable button
    if (noCount === totalCount) { 
      $('#part1-alert').addClass('text-sb-green').removeClass('text-sb-grey-600').html("That's great to hear! As a reminder, We will only issue gift cards for functional used gear that is within the <a href=\"/pages/preloved#preloved-details\" title=\"Standards\" aria-label=\"Standards\">SB Pre-Loved program standards</a>. Any gear that doesn't pass muster will be donated. No items will be returned to you for any reason."); 
      $('#part1 input.userVerify').prop('disabled', false);
    } 
  });
  
  // Part 2
  $('#part2 input[type=radio]').on('click tap', function(){
    var isBasementeer = $(this).val();
    if (isBasementeer === 'YES') {
      $('#part2-alert').addClass('text-sb-green').removeClass('text-sb-grey-600').html("At this time, you must be a Basementeer to participate in the SB Pre-Loved Trade-In Program."); 
      $('#part2 input.userVerify').prop('disabled', false);
    } else {
      $('#part2-alert').addClass('text-sb-grey-600').removeClass('text-sb-green').html("Unfortunately only Basementeers are eligible to trade-in items for credit. Learn how to join the Basementeer program (and all the awesome extras you get) <a href=\"/products/basementeer-membership-1#bteers-product\" title=\"Join the Basementeers\" aria-label=\"Join the Basementeers\">here</a>!"); 
      $('#part2 input.userVerify').prop('disabled', true);  
    }
  });
  
  // Part 3
  var addendumShip = `
    <div class="mx-4"> 
      <h4 class="text-sb-green"><strong>Enter your address</strong></h4> 
      <div class="form-group"> 
        <label for="address" class="hidden">Address</label> 
        <input type="text" class="form-control w-full" name="address" placeholder="Address" required> 
      </div> 
      <div class="form-group"> 
        <label for="address2" class="hidden">Address 2</label> 
        <input type="text" class="form-control w-full" name="address2" placeholder="Address 2 (optional)"> 
      </div> 
      <div class="form-row flex flex-nowrap"> 
        <div class="form-group md:col-6"> 
          <label for="city" class="hidden">City</label> 
          <input type="text" class="form-control w-full" name="city" placeholder="City" required> 
        </div> 
        <div class="form-group px-2 md:col-4"> 
          <label for="state" class="hidden">State</label> 
          <select name="state" class="form-control w-full" required> 
            <option value="">State ...</option>
            <option value="AL">Alabama</option> 
            <option value="AK">Alaska</option> 
            <option value="AZ">Arizona</option> 
            <option value="AR">Arkansas</option> 
            <option value="CA">California</option> 
            <option value="CO">Colorado</option> 
            <option value="CT">Connecticut</option> 
            <option value="DE">Delaware</option> 
            <option value="DC">District Of Columbia</option> 
            <option value="FL">Florida</option> 
            <option value="GA">Georgia</option> 
            <option value="HI">Hawaii</option> 
            <option value="ID">Idaho</option> 
            <option value="IL">Illinois</option> 
            <option value="IN">Indiana</option> 
            <option value="IA">Iowa</option> 
            <option value="KS">Kansas</option> 
            <option value="KY">Kentucky</option> 
            <option value="LA">Louisiana</option> 
            <option value="ME">Maine</option> 
            <option value="MD">Maryland</option> 
            <option value="MA">Massachusetts</option> 
            <option value="MI">Michigan</option> 
            <option value="MN">Minnesota</option> 
            <option value="MS">Mississippi</option> 
            <option value="MO">Missouri</option> 
            <option value="MT">Montana</option> 
            <option value="NE">Nebraska</option> 
            <option value="NV">Nevada</option> 
            <option value="NH">New Hampshire</option> 
            <option value="NJ">New Jersey</option> 
            <option value="NM">New Mexico</option> 
            <option value="NY">New York</option> 
            <option value="NC">North Carolina</option> 
            <option value="ND">North Dakota</option> 
            <option value="OH">Ohio</option> 
            <option value="OK">Oklahoma</option> 
            <option value="OR">Oregon</option> 
            <option value="PA">Pennsylvania</option> 
            <option value="RI">Rhode Island</option> 
            <option value="SC">South Carolina</option> 
            <option value="SD">South Dakota</option> 
            <option value="TN">Tennessee</option> 
            <option value="TX">Texas</option> 
            <option value="UT">Utah</option> 
            <option value="VT">Vermont</option> 
            <option value="VA">Virginia</option> 
            <option value="WA">Washington</option> 
            <option value="WV">West Virginia</option> 
            <option value="WI">Wisconsin</option> 
            <option value="WY">Wyoming</option> 
          </select> 
        </div> 
        <div class="form-group md:col-2"> 
          <label for="zip" class="hidden">Zip</label> 
          <input type="text" class="form-control w-full" name="zip" placeholder="Zip code" required> 
        </div> 
      </div> 
    </div>`;

  var addendumDropOff = `
    <h4 class="text-sb-green ml-4"><strong>Select Drop Off Store</strong></h4> 
      <div class="form-group mx-4"> 
        <label for="store" class="hidden">Store</label> 
        <select name="store" class="form-control p-2 rounded w-full" required> 
          <option value="">Store ...</option>
          <option value="Berkeley">Berkeley</option> 
          <option value="Campbell">Campbell</option> 
          <option value="Long Beach">Long Beach</option> 
          <option value="Novato">Novato</option> 
          <option value="Orange County">Orange County</option> 
          <option value="Redwood City">Redwood City</option> 
          <option value="SF Bryant St">SF Bryant St</option> 
          <option value="SF Presidio">SF Presidio</option> 
          <option value="SF Stonestown">SF Stonestown</option> 
          <option value="San Ramon">San Ramon</option> 
          <option value="Santa Rosa">Santa Rosa</option> 
          <option value="Sunnyvale">Sunnyvale</option> 
          <option value="Walnut Creek">Walnut Creek</option> 
        </select> 
      </div>`;

  
  $('#part3 input[name=method]').on('click tap', function(){
    var method = $(this).val();
    if(method === 'SHIP') {
      $('#prelovedFormConfirmationText').html("<p>You're all set! Your shipping label will be emailed to you at the email address you submitted earlier within 24 hours. Remember, $7 will be deducted from your credit to cover the cost of shipping after the return label has been used. You can always drop off your trade-ins at any Sports Basement store for free.</p><p>You will receive an email confirming that you've started the trade-in process in 24-48 hours, with info about your trade-in evaluation as well as a reference number for your records. Stay green!</p><p>Make sure you've <a href=\"https://shop.sportsbasement.com/pages/subscribe-update-your-preferences\" title=\"Email opt-in\" aria-label=\"Email opt-in\">opted into our emails</a> in order to receive all your Pre-Loved communications!</p>"); 
      $('#prelovedFormMethodAddendum').html(addendumShip).slideDown();
    } else {
      $('#prelovedFormConfirmationText').html("<p>We are ready for your gear! You will receive an email confirming that you've started the trade-in process in 24-48 hours, with a reference number for your records. Make sure you've <a href=\"https://shop.sportsbasement.com/pages/subscribe-update-your-preferences\" title=\"Email opt-in\" aria-label=\"Email opt-in\">opted into our emails</a> in order to receive all your Pre-Loved communications!</p><p>The next step is to package up your laundered or cleaned trade-in gear and bring it to any Sports Basement as soon as it is convenient for you. Be sure to write your name and email address on the box. If you do not have your Pre-Loved number yet, not a worry, we can get that for you when you arrive at the store.</p>"); 
      $('#prelovedFormMethodAddendum').html(addendumDropOff).slideDown();
    }
  });
    
  $('#part3 input[type=radio]').on('click tap', function(){
    var checkedCount = $('#part3 input[type=radio]:checked').length;
    var totalCount = ($('#part3 input[type=radio]').length) / 2;

    // if all checked
    if (checkedCount === totalCount) { 
      $('#part3 input.userVerify').prop('disabled', false);
    } 
  });

  $('#part4 input[type=checkbox]').on('click tap', function(){
    let checkedCount = $('#part4 input[type=checkbox]:checked').length;
    let totalCount = $('#part4 input[type=checkbox]').length;

    if (checkedCount === totalCount) {
      $('#part4 input[type=submit]').prop('disabled', false);
    } else {
      $('#part4 input[type=submit]').prop('disabled', true);
    }
  });

  // On submit send data to Google Sheets
  // const scriptURL = 'https://script.google.com/macros/s/AKfycby9YitLya5hfbUDbASh0dB9OzY_6wepoxSQ9j7twnU10Q20o1cVdw82k3DXSGNWHWqQOw/exec' // version 1
  // const scriptURL = 'https://script.google.com/macros/s/AKfycbw417WOfQy-VMd6oD_PyOWbUwutUq57cZ9ret5MKRby-sgEJo3Sp3csnlORrbDQwyAhkw/exec' // version 1.1 (ID #)
  // const scriptURL = 'https://script.google.com/macros/s/AKfycbzLYIly4pdfEXx-yek6MuVCVH7OeKZLHgUdtuTJl5s891LIJFqyuzj7aKsRrl2F02CNew/exec' // version 1.1.1 (ID #)
  const scriptURL = 'https://script.google.com/macros/s/AKfycbz-kr8CO1V5umB1lvTJ884-loUfaHNsYr3WxhPfdzUSaTiAH6Xh31o-Dq7PElGvTu_o/exec' // version 2.1 - pre-2024 archived
  const form = document.forms['prelovedUserInput']
  
  // SHOW FORM CONFIRMATION
  function formSuccess () {
    $(form).hide();
    $('#prelovedFormConfirmation').show();
    dataLayer.push({'event':'PreLoved_Form_Submit'}); 
    $('html, body').animate({
      scrollTop: $("body").offset().top
    }, 500);
  }

  form.addEventListener('submit', e => {
    e.preventDefault()
    $('input[type=submit]').prop('disabled', true).val('Sending...');
    fetch(scriptURL, { crossDomain: true, method: 'POST', body: new FormData(form)})
      .then(response => console.log('Success!', response))
      .then(formSuccess)
      .catch(error => console.error('Error!', error.message))
  })
  
});